module.exports = __webpack_public_path__ + "img/emotion-hands.57b9abda.svg";